import React from "react";
import Table from "../../../../../../common/element/Table";
import moment from "moment";

const { Tr, Th, Td, THead, TBody } = Table;

const formatDate = (value) =>
  value ? moment(value).format("DD/MM/YYYY") : "-";

const DeactivatedPaymentsList = ({ rows = [] }) => {
  if (!Array.isArray(rows) || rows.length === 0) {
    return (
      <div className="border border-gray-200 rounded-lg p-6 text-center text-sm text-gray-500">
        No deactivated payments found for the selected filters.
      </div>
    );
  }

  const formatNumber = (value) =>
    value === null || value === undefined || Number.isNaN(Number(value))
      ? "-"
      : Number(value).toString();

  return (
    <div className="overflow-hidden border rounded-lg border-gray-200">
      <Table>
        <THead>
          <Tr>
            <Th>Provider</Th>
            <Th>Provider type</Th>
            <Th>Renewal due</Th>
            <Th>Days overdue</Th>
            <Th>Inactive on</Th>
            <Th>Days since inactive</Th>
            <Th>Primary contact</Th>
            <Th>Contact email</Th>
            <Th>Contact phone</Th>
            <Th>Follow-up status</Th>
            <Th>Follow-up notes</Th>
            <Th>Completed on</Th>
            <Th>Completed by</Th>
          </Tr>
        </THead>
        <TBody>
          {rows.map((row, index) => (
            <Tr key={row?.licence_id ?? row?.provider_org_id ?? index}>
              <Td>{row?.provider_trading_name ?? row?.provider_name ?? "-"}</Td>
              <Td>{row?.provider_type_name ?? row?.provider_type ?? "-"}</Td>
              <Td>{formatDate(row?.renewal_due_date)}</Td>
              <Td>{formatNumber(row?.days_since_due)}</Td>
              <Td>{formatDate(row?.inactive_on)}</Td>
              <Td>{formatNumber(row?.days_since_inactive)}</Td>
              <Td>{row?.primary_contact_name ?? "-"}</Td>
              <Td>{row?.primary_contact_email ?? "-"}</Td>
              <Td>{row?.primary_contact_phone ?? "-"}</Td>
              <Td>{row?.follow_up_status ?? row?.status ?? "-"}</Td>
              <Td>{row?.follow_up_notes ?? row?.notes ?? "-"}</Td>
              <Td>{formatDate(row?.follow_up_completed_on)}</Td>
              <Td>{row?.follow_up_completed_by ?? "-"}</Td>
            </Tr>
          ))}
        </TBody>
      </Table>
    </div>
  );
};

export default DeactivatedPaymentsList;
